<template>
    <div class="finance">
        <ChildPublic v-if="isChild==1"></ChildPublic>
        <Public v-else-if="isChild==0"></Public>

        <div class="finance-content right-content">
            <el-tabs v-model="activeIndex" type="card" @tab-click="handleClick">
                <el-tab-pane v-if="isChild==0" label="充值记录" name="1">
                    <!--<div style="margin-right: 0.15rem;">-->
                        <FinanceRecharge></FinanceRecharge>
                    <!--</div>-->
                </el-tab-pane>

                <el-tab-pane v-if="isChild==0" label="提现记录" name="2">
                    <div style="margin-right: 0.15rem;">
                        <FinanceWithdraw></FinanceWithdraw>
                    </div>
                </el-tab-pane>


                <!--<el-tab-pane label="结算管理" name="third">-->
                    <!--<div style="margin-right: 0.15rem;">-->

                    <!--</div>-->
                <!--</el-tab-pane>-->

                <el-tab-pane v-if="isChild==1" label="充值记录" name="1">
                    <!--<div style="margin-right: 0.15rem;">-->
                    <FinanceRechargeCil></FinanceRechargeCil>
                    <!--</div>-->
                </el-tab-pane>
            </el-tabs>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    import Public from '@/views/Public.vue'
    import ChildPublic from '@/views/ChildPublic.vue'
    import FinanceRecharge from '@/components/FinanceRecharge.vue'
    import FinanceWithdraw from '@/components/FinanceWithdraw.vue'
    import FinanceRechargeCil from '@/components/FinanceRechargeCil.vue'
    export default {
        name: "Finance",
        components: {
            Public,
            ChildPublic,
            FinanceRecharge,
            FinanceWithdraw,
            FinanceRechargeCil
        },
        data() {
            return {
                activeIndex: '1',
                isChild:window.localStorage.isChild,
            };
        },
        mounted: function () {
            this.activeIndex = store.state.financeTableTabIndex;
        },
        methods: {
            handleClick(tab, event) {
                store.commit('assignFinanceTableTabIndex', this.activeIndex);
            },
        }
    }
</script>

<style scoped>
    .finance {
        height: 100%;
    }

    .finance-content {
        margin: 0.1rem 0 0.1rem 0.15rem;
    }
    /*.el-tab-pane{*/
        /*margin-right: 0.15rem;*/
    /*}*/
    /*.el-tabs__content{*/
        /*margin-right:0.15rem;*/
    /*}*/
    /*.right-content .el-tabs__content {*/
        /*margin-right:0.15rem;*/
    /*}*/
</style>